import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../Wrapper/GlobalWrapper';
import { Alert, Box, Button, Typography } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';

const NavigationModel = ({ redirectUrl, title, navigationTo }) => {
  const [autoOpened, setAutoOpened] = useState(false);
  useEffect(() => {
    const newTab = window.open(redirectUrl, '_blank');

    if (newTab) {
      setAutoOpened(true);
    }
  }, [redirectUrl]);

  return (
    <GlobalWrapper title={title}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          minHeight: '60vh',
          textAlign: 'flex-start',
          pl: 0.5,
        }}
      >
        {/* <Typography variant="h5" fontWeight={600} gutterBottom>
          Navigation Required to Old Portal for TP Verification
        </Typography> */}

        {navigationTo && (
          <Typography variant="body1" color="text.secondary" mb={2}>
            {title} is currently available in our <b>{navigationTo}</b>. We’ve opened it in a new tab for you.
          </Typography>
        )}

        {autoOpened && (
          <Alert severity="info" sx={{ mb: 2, maxWidth: 600 }}>
            If the {title} page did not open automatically, please use the button below.
          </Alert>
        )}

        <Button
          startIcon={<Icon icon="ion:navigate-sharp" />}
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => window.open(redirectUrl, '_blank')}
        >
          Open {title}
        </Button>
        <Box mt={1}>
          <Typography variant="caption" color="text.secondary">
            You can safely return to this page after completing the {title}.
          </Typography>
        </Box>
      </Box>
    </GlobalWrapper>
  );
};

export default NavigationModel;
